import React, { useState, useEffect } from "react";
import {
  data,
  mainAnswers,
  ONBOARDING_ID,
  PRIVACY_LINK,
  TERMS_LINK,
} from "../../constants/data";
import { MainBlock } from "./styled";
import { Container, Heading, Text } from "../../styled";
import { useHistory } from "react-router";
import logo from "./../../resources/images/main/logo_new.svg";
import stars from "./../../resources/images/main/stars_bg.png";
import Button from "../design_components/Button/Button";
import { analytics } from "../../firebaseAnalytics";
import { setUserProperties } from "firebase/analytics";
import {
  setExperimentsFirebaseValue,
  analyticsSetFunction,
  analyticsInitFunction,
  checkWebDevice,
  checkOsVersion
} from "../../utils/helper";
import amplitude from "amplitude-js";
import {
  setUserPropertiesAmplitude,
  onBoardingStartEventAmplitude,
} from "../../amplitude/events";
import { onboardingStartEvent } from "../../firebaseAnalytics/events";
import ReactPixel from "react-facebook-pixel";
import axios from "axios";
import { whiteColor } from "../../constants/colors";
import { QuestionBlock } from "../Question/styled";
import Checkbox from "../design_components/Checkbox/Checkbox";

const Main = (props) => {
  const {
    setPixelObject,
    pixelObject,
    remoteConfig,
    noteAnswer,
    isAnalyticsInit,
  } = props;

  const [eventObject, setEventObject] = useState({});
  const [isConfigReady, setConfigReady] = useState(false);
  const [userData, setUserData] = useState({});
  const [user, setUser] = useState(null);
  const [activeCheckBoxes, setActiveCheckBoxes] = useState([]);
  const [ip, setIp] = useState(null);

  const history = useHistory();

  useEffect(() => {
    if (Object.keys(userData).length) {
      const pixelDataObj = {
        ct: userData.city.toLowerCase(),
        st: userData.region.toLowerCase(),
        country: userData.country.toLowerCase(),
        external_id: user,
      };
      setPixelObject(pixelDataObj);
    }
  }, [userData]);

  useEffect(() => {
    if (Object.keys(remoteConfig).length) {
      if (remoteConfig.welcome === false) {
        history.push(data[0].route);
      }
      setConfigReady(true);
    }

    if (
      Object.keys(remoteConfig).length &&
      Object.keys(remoteConfig.experiments).length &&
      !isAnalyticsInit
    ) {
      analyticsInitFunction(remoteConfig);
      analyticsSetFunction(setUser, setEventObject, eventObject, null, null, checkWebDevice(), checkOsVersion());
    }
  }, [remoteConfig]);

  useEffect(() => {
    getGeoInfo();
    // getIpAddress(setIp);
  }, []);

  const getGeoInfo = () => {
    axios.get(
      axios
        .get("https://ipapi.co/json/")
        .then((response) => {
          let data = response.data;
          setUserData(data);
        })
        .catch((error) => {
          console.log(error);
        })
    );
  };

  const handleButtonClick = () => {
    // Pixel onboarding_start
    ReactPixel.trackCustom("Add to wishlist", pixelObject);
    // событие №3
    onboardingStartEvent(analytics, eventObject);
    onBoardingStartEventAmplitude(eventObject);
    history.push(data[0].route);
    // history.push("/onboarding/PersonalizationColors1");
    noteAnswer("main", activeCheckBoxes);
  };

  const handleCheckBoxClick = (index) => {
    const activeIndex = activeCheckBoxes.indexOf(index);
    if (activeIndex !== -1) {
      let newArr = activeCheckBoxes;
      newArr.splice(activeIndex, 1);
      setActiveCheckBoxes([...newArr]);
    } else {
      setActiveCheckBoxes([...activeCheckBoxes, index]);
    }
  };

  const mainAnswersRender = () => {
    return mainAnswers.map((answer, index) => {
      return (
        <QuestionBlock.Answer
          key={`answer-${index}`}
          style={{ marginBottom: 0 }}
        >
          <Checkbox
            isMain={true}
            text={answer.text}
            index={index}
            value={answer.value}
            activeCheckBoxes={activeCheckBoxes}
            setActiveFunction={() => handleCheckBoxClick(index)}
            isActive={activeCheckBoxes.find((checkbox) => checkbox === index)}
          />
        </QuestionBlock.Answer>
      );
    });
  };

  return (
    <MainBlock className={isConfigReady ? "visible" : null}>
      <img className="stars" src={stars} alt="stars" />
      <MainBlock.Mobile>{/*<img src={mobileBg} alt="" />*/}</MainBlock.Mobile>
      <Container.Content>
        <MainBlock.Wrapper>
          <MainBlock.Top>
            <MainBlock.Top.Logo style={{ width: 190 }}>
              <img src={logo} alt="logo" style={{ marginRight: 14 }} />
              <Text.Comment.Name style={{ color: whiteColor, width: 140 }}>
                Journey app is your pocket sleep coach
              </Text.Comment.Name>
            </MainBlock.Top.Logo>
          </MainBlock.Top>
          <MainBlock.Center>
            <Heading.Third style={{ color: whiteColor, marginBottom: 24 }}>
              I want to:
            </Heading.Third>
            <MainBlock.Questions style={{ marginBottom: 20 }}>
              {mainAnswersRender()}
            </MainBlock.Questions>
            <Button
              text={"Continue"}
              isGradient={true}
              type={"default"}
              action={handleButtonClick}
              disabled={!activeCheckBoxes.length}
              isOpacityDisabled={true}
            />
          </MainBlock.Center>
          <MainBlock.Bottom style={{ marginTop: 20 }}>
            <MainBlock.Bottom.Privacy>
              <a href={TERMS_LINK} style={{ fontSize: 12 }}>
                Terms of Use
              </a>
              <a href={PRIVACY_LINK} style={{ fontSize: 12 }}>
                Privacy Policy
              </a>
            </MainBlock.Bottom.Privacy>
            <MainBlock.Bottom.Reg>
              <Text.Fifth style={{ color: whiteColor, fontWeight: 400 }}>
                © 2022 Journey inc. All Rights Reserved.
              </Text.Fifth>
            </MainBlock.Bottom.Reg>
          </MainBlock.Bottom>
        </MainBlock.Wrapper>
      </Container.Content>
    </MainBlock>
  );
};

export default Main;
